
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PagestateService {
  activePage: string = ''; // Initialize the active page as empty

  setActivePage(page: string): void {
    this.activePage = page;
  }
}
